import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import ProdOrdExcel01Actions, { ProdOrdExcel01Types } from '../Stores/ProdOrdExcel01/Actions';

const getAppStore = state => state.app;

const getProdOrdExcel01Store = state => state.prodOrdExcel01;

export function* prodOrdExcel01ShowBatchJobStatus() {
  try {
    const app = yield select(getAppStore);
    const prodOrdExcel01 = yield select(getProdOrdExcel01Store);
    const getData = {};

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `batchJobStatus/showBatchJobStatus/${prodOrdExcel01.strProcType}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      yield put(ProdOrdExcel01Actions.prodOrdExcel01ShowBatchJobStatusSuccess(result.data));
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  }
}

export function* prodOrdExcel01UploadExcel({ formikBag, hdrFile, dtlFile }) {
  try {
    formikBag.setSubmitting(true);
    yield put(ProdOrdExcel01Actions.prodOrdExcel01UploadLoading(true));

    const app = yield select(getAppStore);

    yield put(ProdOrdExcel01Actions.prodOrdExcel01SetStrProcType('PROD_ORD_EXCEL_01'));
    // eslint-disable-next-line no-undef
    const postData = new FormData();
    postData.append('file1', hdrFile);
    postData.append('file2', dtlFile);

    const getData = {};

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `prodOrd/uploadProcess/PROD_ORD_EXCEL_01/${app.curSiteFlowId}/${app.curDivisionId}`,
      app.token,
      postData,
      getData,
      'multipart/form-data'
    );

    if (result.isSuccess === true) {
      // result.data is total
      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    formikBag.setSubmitting(false);
    yield put(ProdOrdExcel01Actions.prodOrdExcel01UploadLoading(false));
  }
}

export const saga = [
  takeLatest(
    ProdOrdExcel01Types.PROD_ORD_EXCEL01_SHOW_BATCH_JOB_STATUS,
    prodOrdExcel01ShowBatchJobStatus
  ),
  takeLatest(ProdOrdExcel01Types.PROD_ORD_EXCEL01_UPLOAD_EXCEL, prodOrdExcel01UploadExcel)
];
